import { getUserRef } from "../../utils/referenceMappers";

export default function createTerminationData(terminated = false, user = null) {
	return {
		status: terminated === true,
		user: getUserRef(user),
		timestamp: terminated !== null ? new Date() : null,
	};
}
